import { render, staticRenderFns } from "./ResourcePage.vue?vue&type=template&id=d01867fe&scoped=true&"
import script from "./ResourcePage.vue?vue&type=script&lang=js&"
export * from "./ResourcePage.vue?vue&type=script&lang=js&"
import style0 from "./ResourcePage.vue?vue&type=style&index=0&id=d01867fe&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d01867fe",
  null
  
)

export default component.exports